import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";

import { Loading } from "./utils";

const TwitterRanking = (props) => {
  const title = "Twitter Power Ranking";
  const [twitter, setTwitter] = useState({});
  const [view, setView] = useState([]);

  const filter = (e) => {
    const key = e.target.textContent;
    if (key === "All") {
      setView(twitter.data.sort((a, b) => (a.follower > b.follower ? -1 : 1)));
    } else {
      setView(
        twitter.data
          .filter((player) => player.tags.match(new RegExp(key, "ig")))
          .sort((a, b) => (a.follower > b.follower ? -1 : 1))
      );
    }
  };

  useEffect(() => {
    (async () => {
      const res = await fetch(
        "https://script.google.com/macros/s/" +
          process.env.REACT_APP_SHEET_ID +
          "/exec?q=twitter"
      );
      const json = await res.json();
      setTwitter(json);
      setView(json.data.sort((a, b) => (a.follower > b.follower ? -1 : 1)));
    })();
  }, []);

  return (
    <div className="common-wrapper">
      <Helmet
        title={title}
        meta={[
          { name: "twitter:card", content: "summary" },
          {
            property: "og:url",
            content:
              "https://sightstones.netlify.app" + props.location.pathname,
          },
          { property: "og:title", content: title },
          {
            property: "og:image",
            content: "https://sightstones.netlify.app/img/ogp.png",
          },
        ]}
      />
      <div className="container twitter">
        <div className="row">
          <div className="col">
            <header>
              <p className="text-right">Last Update: {twitter.updated}</p>
              <h1 className="my-5 h2 stream-title text-center">{title}</h1>
            </header>
          </div>
        </div>
        <div className="row">
          {!twitter.data ? (
            <Loading />
          ) : (
            <div className="col-md-8">
              <table className="table">
                <thead>
                  <tr>
                    <th>Rank</th>
                    <th>Name</th>
                    <th>Twitter</th>
                    <th>Follower</th>
                    <th>Tweets</th>
                    <th>FpT</th>
                  </tr>
                </thead>
                <tbody>
                  {view.map((player, i) => (
                    <tr key={player.name} className={player.tags}>
                      <td>{i + 1}</td>
                      <td>{player.name}</td>
                      <td>
                        <a
                          href={"https://twitter.com/" + player.screen_name}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {player.screen_name}
                        </a>
                      </td>
                      <td>{player.follower}</td>
                      <td>{player.tweets.toString()}</td>
                      <td>
                        {Math.round((player.follower / player.tweets) * 100) /
                          100}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <div className="col-md-4">
            <div className="bg-light p-4">
              <CategoryButtons onClick={filter} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const CategoryButtons = (props) => {
  const create = (categories) => {
    return categories.map((cat) => (
      <div className="pb-4" key={cat.name}>
        <h5>{cat.name}</h5>
        {cat.list.map((text) => (
          <button onClick={props.onClick} className="btn btn-primary mr-1 mb-1">
            {text}
          </button>
        ))}
      </div>
    ));
  };

  return (
    <>
      {create([
        {
          name: "Categories",
          list: [
            "All",
            "Pro",
            "Streamer",
            "Caster",
            "Writer",
            "Twitter",
            "Rioter",
            "Official",
            "Team",
            "KR",
          ],
        },
        {
          name: "Team",
          list: ["DFM", "SG", "V3", "AXZ", "RJ", "CGA", "BC", "SHG"],
        },
        {
          name: "Role",
          list: ["Top", "Jungle", "Mid", "ADC", "Support", "Coach", "Staff"],
        },
      ])}
    </>
  );
};

export default TwitterRanking;
